import CleverPushEmail from './email';

export default new CleverPushEmail();
